import React from "react";
import withStyles from "@material-ui/styles/withStyles";

import { Container, Grid } from "@material-ui/core";

import Carousel from "react-material-ui-carousel";
import CarouselItem from "./Portfolio/CarouselItem";

import {
  styles,
} from "./Portfolio.styles";

function Portfolio({ classes }) {

  var items = [
    {
      name: "Monitorização",
      description:
        "Acesso online e tempo real a informação sobre temperatura, humidade, ph, co2, etc",
      img: "./images/img01.jpg",
    },
    {
      name: "Automatização",
      description:
        "Controle remotamente a rega, defina um horário, ou deixe que o sistema tome decisões por si",
      img: "./images/img02.jpg",
    },
    {
      name: "Accessibilidade",
      description:
        "Construimos soluções simples e com preços competitivos e adaptados às necessidades reais de cada projecto",
      img: "./images/img03.jpg",
    },
  ];

  return <Container maxWidth="md" className={classes.root}>
    <Grid container>
        <Grid item xs={12} sm={12}>
          <Carousel interval="5000" navButtonsAlwaysInvisible autoPlay={true} animation="slide" className={classes.carousel}>
            {items.map((item, i) => (
              <CarouselItem key={i} item={{ ...item }} />
            ))}
          </Carousel>
        </Grid>
      </Grid>
  </Container>;
}

export default withStyles(styles)(Portfolio);
